// libs
import React, { memo } from 'react';

// styles
import { Container } from './styles';

// defs
interface IActionContainerProps {
  children: React.ReactNode;
  isBottomSheet?: boolean;
  className?: string;
}

function ActionContainer({
  children,
  isBottomSheet = false,
  className = '',
}: IActionContainerProps) {
  return (
    <Container
      isBottomSheet={isBottomSheet}
      id="pdp-bottom-cta-container"
      className={`actionContainer ${className}`}
      showBorder={true}
    >
      {children}
    </Container>
  );
}

export default memo(ActionContainer);
